<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.BusinessUnitAddress">Business Unit Address</mat-card-title>
  <mat-card-content>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field matTooltip="Select a Business Unit from the list" [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.BusinessUnitAddress.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnitFilterInput"              
              (ngModelChange)="businessUnitChanging($event)" [(ngModel)]="businessUnitFilter"              
              (ngModelChange)="businessUnitChanged($event)" #businessUnitFilterInput              
              placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Select a Addr Type from the list" [matTooltipDisabled]="disabledTooltip(this.addrType)">
          <mat-label i18n="@@type.BusinessUnitAddress.addrType">Addr Type</mat-label>
          <mat-select formControlName="addrType" id="addrTypeFilterInput"              
              (ngModelChange)="addrTypeChanging($event)" [(ngModel)]="addrTypeFilter"              
              (ngModelChange)="addrTypeChanged($event)" #addrTypeFilterInput              
              placeholder="Addr Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let addrType of addrTypeSelectionList" [value]="addrType.code">
              {{addrType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field matTooltip="Description" [matTooltipDisabled]="disabledTooltip(this.description)">
          <mat-label i18n="@@type.BusinessUnitAddress.description">Description</mat-label>
          <input matInput formControlName="description" id="descriptionFilterInput"              
              (ngModelChange)="descriptionChanging($event)" [(ngModel)]="descriptionFilter"              
              (ngModelChange)="descriptionChanged($event)" #descriptionFilterInput              
              maxlength="255" placeholder="Description">
        </mat-form-field>
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Addr1" [matTooltipDisabled]="disabledTooltip(this.addr1)">
          <mat-label i18n="@@type.BusinessUnitAddress.addr1">Addr1</mat-label>
          <input matInput formControlName="addr1" id="addr1FilterInput"              
              (ngModelChange)="addr1Changing($event)" [(ngModel)]="addr1Filter"              
              (ngModelChange)="addr1Changed($event)" #addr1FilterInput              
              maxlength="255" placeholder="Addr1">
        </mat-form-field>

        <mat-form-field matTooltip="Addr2" [matTooltipDisabled]="disabledTooltip(this.addr2)">
          <mat-label i18n="@@type.BusinessUnitAddress.addr2">Addr2</mat-label>
          <input matInput formControlName="addr2" id="addr2FilterInput"              
              (ngModelChange)="addr2Changing($event)" [(ngModel)]="addr2Filter"              
              (ngModelChange)="addr2Changed($event)" #addr2FilterInput              
              maxlength="255" placeholder="Addr2">
        </mat-form-field>

        <mat-form-field matTooltip="Addr3" [matTooltipDisabled]="disabledTooltip(this.addr3)">
          <mat-label i18n="@@type.BusinessUnitAddress.addr3">Addr3</mat-label>
          <input matInput formControlName="addr3" id="addr3FilterInput"              
              (ngModelChange)="addr3Changing($event)" [(ngModel)]="addr3Filter"              
              (ngModelChange)="addr3Changed($event)" #addr3FilterInput              
              maxlength="255" placeholder="Addr3">
        </mat-form-field>

        <mat-form-field matTooltip="Town" [matTooltipDisabled]="disabledTooltip(this.town)">
          <mat-label i18n="@@type.BusinessUnitAddress.town">Town</mat-label>
          <input matInput formControlName="town" id="townFilterInput"              
              (ngModelChange)="townChanging($event)" [(ngModel)]="townFilter"              
              (ngModelChange)="townChanged($event)" #townFilterInput              
              maxlength="255" placeholder="Town">
        </mat-form-field>

        <mat-form-field matTooltip="County" [matTooltipDisabled]="disabledTooltip(this.county)">
          <mat-label i18n="@@type.BusinessUnitAddress.county">County</mat-label>
          <input matInput formControlName="county" id="countyFilterInput"              
              (ngModelChange)="countyChanging($event)" [(ngModel)]="countyFilter"              
              (ngModelChange)="countyChanged($event)" #countyFilterInput              
              maxlength="255" placeholder="County">
        </mat-form-field>

        <mat-form-field matTooltip="Postcode" [matTooltipDisabled]="disabledTooltip(this.postcode)">
          <mat-label i18n="@@type.BusinessUnitAddress.postcode">Postcode</mat-label>
          <input matInput formControlName="postcode" id="postcodeFilterInput"              
              (ngModelChange)="postcodeChanging($event)" [(ngModel)]="postcodeFilter"              
              (ngModelChange)="postcodeChanged($event)" #postcodeFilterInput              
              maxlength="8" placeholder="Postcode">
        </mat-form-field>

		
      </div>
      
      <div class="search-section">

        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.BusinessUnitAddress.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdByFilterInput"              
              (ngModelChange)="createdByChanging($event)" [(ngModel)]="createdByFilter"              
              (ngModelChange)="createdByChanged($event)" #createdByFilterInput              
              maxlength="255" placeholder="Created By">
        </mat-form-field>

        <mat-form-field matTooltip="Created Date From" [matTooltipDisabled]="disabledTooltip(this.createdDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.BusinessUnitAddress.createdDateGreaterThanOrEqualTo">Created Date From</mat-label>
          <input matInput formControlName="createdDateGreaterThanOrEqualTo" id="createdDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="createdDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="createdDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="createdDateGreaterThanOrEqualToChanged($event)" #createdDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="createdDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Created Date From">
          <mat-datepicker-toggle matSuffix [for]="createdDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Created Date To" [matTooltipDisabled]="disabledTooltip(this.createdDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.BusinessUnitAddress.createdDateLessThanOrEqualTo">Created Date To</mat-label>
          <input matInput formControlName="createdDateLessThanOrEqualTo" id="createdDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="createdDateLessThanOrEqualToChanging($event)" [(ngModel)]="createdDateLessThanOrEqualToFilter"              
              (ngModelChange)="createdDateLessThanOrEqualToChanged($event)" #createdDateLessThanOrEqualToFilterInput              
              [matDatepicker]="createdDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Created Date To">
          <mat-datepicker-toggle matSuffix [for]="createdDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>

        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.BusinessUnitAddress.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedByFilterInput"              
              (ngModelChange)="updatedByChanging($event)" [(ngModel)]="updatedByFilter"              
              (ngModelChange)="updatedByChanged($event)" #updatedByFilterInput              
              maxlength="255" placeholder="Updated By">
        </mat-form-field>

        <mat-form-field matTooltip="Updated Date From" [matTooltipDisabled]="disabledTooltip(this.updatedDateGreaterThanOrEqualTo)">
          <mat-label i18n="@@type.BusinessUnitAddress.updatedDateGreaterThanOrEqualTo">Updated Date From</mat-label>
          <input matInput formControlName="updatedDateGreaterThanOrEqualTo" id="updatedDateGreaterThanOrEqualToFilterInput"              
              (ngModelChange)="updatedDateGreaterThanOrEqualToChanging($event)" [(ngModel)]="updatedDateGreaterThanOrEqualToFilter"              
              (ngModelChange)="updatedDateGreaterThanOrEqualToChanged($event)" #updatedDateGreaterThanOrEqualToFilterInput              
              [matDatepicker]="updatedDateGreaterThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Updated Date From">
          <mat-datepicker-toggle matSuffix [for]="updatedDateGreaterThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateGreaterThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>  
        <mat-form-field matTooltip="Updated Date To" [matTooltipDisabled]="disabledTooltip(this.updatedDateLessThanOrEqualTo)">
          <mat-label i18n="@@type.BusinessUnitAddress.updatedDateLessThanOrEqualTo">Updated Date To</mat-label>
          <input matInput formControlName="updatedDateLessThanOrEqualTo" id="updatedDateLessThanOrEqualToFilterInput"              
              (ngModelChange)="updatedDateLessThanOrEqualToChanging($event)" [(ngModel)]="updatedDateLessThanOrEqualToFilter"              
              (ngModelChange)="updatedDateLessThanOrEqualToChanged($event)" #updatedDateLessThanOrEqualToFilterInput              
              [matDatepicker]="updatedDateLessThanOrEqualToDatePicker" (dateChange)="maybeDoAutoSearch()"              
              placeholder="Updated Date To">
          <mat-datepicker-toggle matSuffix [for]="updatedDateLessThanOrEqualToDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateLessThanOrEqualToDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
		
      </div>
      
      <div class="search-section">

		<mat-slide-toggle floatLabel="always" appearance="none" color="primary"  *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch"  [ngModelOptions]="{standalone: true}">
            Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>
		  

        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
			
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort
                           matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                           cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <ng-container matColumnDef="businessUnitAddressId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnitAddressId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.businessUnitAddressId">
                Business Unit Address Id 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.businessUnitAddressId | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="businessUnit.buId">
            <mat-header-cell [crud-column-header]="columns.column('businessUnit.buId')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.businessUnit">
                Business Unit 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.businessUnit?.buId}} - {{element.businessUnit?.name}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="addr1">
            <mat-header-cell [crud-column-header]="columns.column('addr1')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.addr1">
                Addr1 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addr1}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="addr2">
            <mat-header-cell [crud-column-header]="columns.column('addr2')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.addr2">
                Addr2 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addr2}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="addr3">
            <mat-header-cell [crud-column-header]="columns.column('addr3')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.addr3">
                Addr3 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addr3}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="addrType">
            <mat-header-cell [crud-column-header]="columns.column('addrType')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.addrType">
                Addr Type 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.addrType | refDecode:'BU_ADDR_TYPE' | async}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="county">
            <mat-header-cell [crud-column-header]="columns.column('county')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.county">
                County 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.county}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdBy">
            <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.createdBy">
                Created By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="createdDate">
            <mat-header-cell [crud-column-header]="columns.column('createdDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.createdDate">
                Created Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.createdDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="description">
            <mat-header-cell [crud-column-header]="columns.column('description')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.description">
                Description 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.description}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="lockVersion">
            <mat-header-cell [crud-column-header]="columns.column('lockVersion')" *matHeaderCellDef 
              cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.lockVersion">
                Lock Version 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.lockVersion | number:'1.0-2':'en-GB'}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="postcode">
            <mat-header-cell [crud-column-header]="columns.column('postcode')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.postcode">
                Postcode 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.postcode}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="town">
            <mat-header-cell [crud-column-header]="columns.column('town')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.town">
                Town 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.town}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell [crud-column-header]="columns.column('updatedBy')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.updatedBy">
                Updated By 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedBy}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="updatedDate">
            <mat-header-cell [crud-column-header]="columns.column('updatedDate')" *matHeaderCellDef 
              mat-sort-header cdkDropList cdkDropListLockAxis="x"
              cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
              class="search-column-small" i18n="@@type.BusinessUnitAddress.updatedDate">
                Updated Date 
              </mat-header-cell>
            <mat-cell class="search-column-small" *matCellDef="let element">
              {{element.updatedDate | uimDateTimeFormat}}
            </mat-cell>
          </ng-container>  

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit" id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)" mat-raised-button color="primary"
                [routerLink]="viewRoute(element)" i18n="@@actions.view" id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary" [routerLink]="createRoute()"
        [queryParams]="createRouteQueryParams()" i18n="@@actions.create" id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>